import { combineReducers } from 'redux';
import { all, fork } from 'redux-saga/effects';
import { RemoteData } from '../../models';
import { PostList } from '@/models/post';
import { baseInfoReducer, BaseInfoState, sagas as baseSagas } from './common/base';

export interface ReduxState {
  posts: RemoteData<PostList>;
  baseInfo: BaseInfoState;
}

export function* rootSaga() {
  yield all([fork(baseSagas)]);
}

const createRootReducer = () =>
  combineReducers({
    baseInfo: baseInfoReducer,
  });

export default createRootReducer;
